import { useSelector } from "react-redux";
import { selectOrdersCreatedItem } from "../../../../redux/orders/selector";
import * as  R from 'ramda';
import { useEffect } from "react";
import { variants } from "../../../../redux/variants/action";
import { selectVariantsListItems } from "../../../../redux/variants/selector";
import { useAppDispatch } from "../../../../hooks/hooks";
import { currency } from "../../../../common/services/common.service";
import { useNavigate } from "react-router-dom";
import { cargoLeads } from "../../../../redux/cargo-lead/action";
import { format } from "../../../../common/services/date.service";
import { selectAnnouncementsListItems } from "../../../../redux/announcements/selector";
import _ from "lodash";
import { announcements } from "../../../../redux/announcements/action";
import PageLoader from "../../../../components/PageLoader";

const CargoOrderDetailsMobile = () => {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const orderDetails = useSelector(selectOrdersCreatedItem)
    const variantLists = useSelector(selectVariantsListItems)
    const announcementsList = useSelector(selectAnnouncementsListItems)
    let fareAmount = _.find(announcementsList.result.items, ['Title', 'fareAmount']);

    const back = () => {
        dispatch(cargoLeads.resetAction({ actionType: 'create' }))
        navigate('/cargo')
    }
    const getProductName = (LogisticsVariantId: any) => {
        const Variant = R.find(
            (variant: any) => parseInt(
                variant.Id,
                10
            ) === parseInt(
                LogisticsVariantId,
                10
            ),
            variantLists?.result?.items
        )
        return Variant ? Variant.Name : ''
    }
    const orderData = orderDetails?.result?.items?.Records[0]?.message?.order
    useEffect(
        () => {
            dispatch(variants.list({
                url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/variants/list`, entity: 'variants', jsonData: {}
            }))
            dispatch(announcements.list({
                url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/announcements/list`,
                entity: 'announcements',
                jsonData: {}
            }))
        },
        []
    );
    return (
        <>
            {announcementsList?.isLoading ? <PageLoader /> :
                <div className="py-6 px-4">
                    <div className="flex justify-end">
                        <button
                            onClick={back}
                            type="button"
                            className="w-auto text-primary rounded font-medium px-4 py-3">
                            &larr; Back To Booking
                        </button>
                    </div>
                    <div className="font-bold mb-4 text-lg text-center">
                        Thank you for Booking
                    </div>
                    <div className="font-medium text-sm mb-4 text-left">
                        Booking ID : {orderData?.id}
                    </div>
                    <div className="border-b border-gray-400"></div>

                    <div className="w-full flex flex-col text-center space-y-6 pt-6">
                        <div className="space-y-4">
                            <div>
                                <label className="text-sm font-semibold block">Vehicle Type</label>
                                <label className="text-sm block mt-1">{orderData?.fulfillments[0]?.vehicle?.vehicleType}</label>
                            </div>
                            <div>
                                <label className="text-sm font-semibold block">Product Type</label>
                                <label className="text-sm block mt-1">{orderData?.["@ondc/org/linked_order"]?.items?.[0]?.CategoryName}</label>
                            </div>
                            <div>
                                <label className="text-sm font-semibold block">Payment Type</label>
                                <label className="text-sm block mt-1">{orderData?.payment?.method}</label>
                            </div>
                            <div>
                                <label className="text-sm font-semibold block">Amount</label>
                                <label className="text-sm block mt-1">{currency(orderData?.quote?.price?.value)}</label>
                            </div>
                        </div>

                        <div className="space-y-4">
                            <div>
                                <label className="text-sm font-semibold block">Pickup Address</label>
                                <label className="text-xs block mt-1">
                                    {orderData?.fulfillments[0]?.start?.location?.address?.locality},
                                    {orderData?.fulfillments[0]?.start?.location?.address?.city} -
                                    {orderData?.fulfillments[0]?.start?.location?.address?.area_code},
                                    {orderData?.fulfillments[0]?.start?.location?.address?.state},
                                    {orderData?.fulfillments[0]?.start?.location?.address?.country}
                                </label>
                            </div>
                            <div>
                                <label className="text-sm font-semibold block">Drop Address</label>
                                <label className="text-xs block mt-1">
                                    {orderData?.fulfillments[0]?.end?.location?.address?.locality},
                                    {orderData?.fulfillments[0]?.end?.location?.address?.city} -
                                    {orderData?.fulfillments[0]?.end?.location?.address?.area_code},
                                    {orderData?.fulfillments[0]?.end?.location?.address?.state},
                                    {orderData?.fulfillments[0]?.end?.location?.address?.country}
                                </label>
                            </div>
                            <div>
                                <label className="text-sm font-semibold block">Order Date</label>
                                <label className="text-sm block mt-1">{format(orderData?.created_at)}</label>
                            </div>
                        </div>
                    </div>
                    <div className="border-b border-gray-400 py-3"></div>
                    <label className="text-xs text-left">Note: {fareAmount?.Description}</label>
                </div>
            }
        </>


    );
};

export default CargoOrderDetailsMobile;


